import React, { useEffect, useState } from 'react';
import { Clock3Icon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const endOfDay = new Date(now);
  endOfDay.setHours(24, 0, 0, 0);
  const remaining = Math.max(0, endOfDay.getTime() - now.getTime());
  const totalSeconds = Math.floor(remaining / 1000);
  return {
    hours: String(Math.floor(totalSeconds / 3600)).padStart(2, '0'),
    minutes: String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0'),
    seconds: String(totalSeconds % 60).padStart(2, '0')
  };
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-196" data-mp="2nlrw0otiegoq">
      <span className="font-serif-display text-3xl font-bold leading-none text-white sm:text-4xl" data-id="element-197" data-mp="29ov56nde4z7u">
        {value}
      </span>
      <span className="mt-1 text-[10px] font-bold tracking-[0.13em] text-white/55" data-id="element-198" data-mp="2epag78a79umn">{label}</span>
    </div>;
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Time remaining on today's maker offer" className="mt-4 overflow-hidden rounded-2xl bg-navy px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(17,35,63,0.8)] sm:px-5" data-id="element-199" data-mp="n6c390284qad">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-200" data-mp="3rktq8yak8wdy">
        <div className="min-w-0" data-id="element-201" data-mp="4i72m1gv5lfs">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-navy" data-id="element-202" data-mp="4h5fuzqhjai8">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-203" data-mp="37ynnb62cifi4" />
            TODAY&rsquo;S MAKER OFFER
          </span>
          <p className="mt-2 text-sm leading-snug text-white/85" data-id="element-204" data-mp="1bw131i3frxus">
            Get the complete Young Inventor Lab™ for $27 USD while this offer is active.
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="off" data-id="element-205" data-mp="1llklwnr5frpn">
          <Clock3Icon className="hidden h-5 w-5 text-yellow sm:block" aria-hidden="true" data-id="element-206" data-mp="1qkfeuiitywnh" />
          <TimeUnit value={offerTime.hours} label="HRS" data-id="element-207" data-mp="1qm8br63n62ia" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-yellow" aria-hidden="true" data-id="element-208" data-mp="sxyj3hpqwr3u">
            :
          </span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-209" data-mp="xxue4rggt879" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-yellow" aria-hidden="true" data-id="element-210" data-mp="12trqkmolxuer">
            :
          </span>
          <TimeUnit value={offerTime.seconds} label="SEC" data-id="element-211" data-mp="16ubo3rd3f01f" />
        </div>
      </div>

      <div className="mt-3 border-t border-white/10 pt-3 text-center text-xs text-white/60 sm:text-left" data-id="element-212" data-mp="2e9giztkmrlmy">
        Offer timing must match the real checkout promotion.
      </div>
    </aside>;
}